import styled from 'styled-components'

export const FormContainer = styled.div`
  .react-datepicker__day--outside-month {
    opacity: 0.3;
  }
`

export const List = styled.ul`
  max-height: 490px;
  width: 400px;
`
